interface PollingIndicatorProps {
  paused: boolean;
  onToggle: () => void;
}

export function PollingIndicator({ paused, onToggle }: PollingIndicatorProps) {
  return (
    <span className="polling-indicator">
      <span className={`polling-dot ${paused ? '' : 'polling-dot-live'}`} aria-hidden="true" />
      {paused ? 'Paused' : 'Live'}
      <button type="button" className="ghost-button polling-toggle" onClick={onToggle}>
        {paused ? 'Resume' : 'Pause'}
      </button>
    </span>
  );
}
